module.exports = new __parcel__URL__("kick_2.eef489eb.mp3").toString();